// extracted by mini-css-extract-plugin
export default {"sub_category":"SubCategory_sub_category__wIXjt","image":"SubCategory_image__OWYSI","sub_category_name":"SubCategory_sub_category_name__cYH7R"};